import { PANEL_TYPE } from 'src/utils/status';
import { BADGE_TYPES } from 'src/components/Elements/Badge';

const BADGE_TYPE = Object.freeze({
  [PANEL_TYPE.PENDING]: { badge: { type: BADGE_TYPES.PENDING } },
  [PANEL_TYPE.CONFIRMED]: { badge: { type: BADGE_TYPES.CONFIRMED } },
  [PANEL_TYPE.EN_ROUTE]: { badge: { type: BADGE_TYPES.CONFIRMED } },
  [PANEL_TYPE.STARTED]: { badge: { type: BADGE_TYPES.CONFIRMED } },
  [PANEL_TYPE.COMPLETED]: { badge: { type: BADGE_TYPES.COMPLETED, variant: 'solid' } },
  [PANEL_TYPE.CANCELLED]: { badge: { type: BADGE_TYPES.CANCELLED } },
  [PANEL_TYPE.UNSERVICEABLE]: {},
  [PANEL_TYPE.STAND_BY]: { badge: { type: BADGE_TYPES.WARNING } },
  [PANEL_TYPE.TECH_LATE]: { badge: { type: BADGE_TYPES.WARNING } },
  [PANEL_TYPE.RESCHEDULE]: { badge: { type: BADGE_TYPES.WARNING } },
});

export default BADGE_TYPE;
